import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/Register.vue')
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/views/ForgotPassword.vue')
    },

    {
      path: '/agreements/user-agreement-zh',
      name: 'UserAgreementZh',
      component: () => import('@/views/agreements/UserAgreementZh.vue')
    },
    {
      path: '/agreements/user-agreement-en',
      name: 'UserAgreementEn',
      component: () => import('@/views/agreements/UserAgreementEn.vue')
    },
    {
      path: '/agreements/privacy-policy-zh',
      name: 'PrivacyPolicyZh',
      component: () => import('@/views/agreements/PrivacyPolicyZh.vue')
    },
    {
      path: '/agreements/privacy-policy-en',
      name: 'PrivacyPolicyEn',
      component: () => import('@/views/agreements/PrivacyPolicyEn.vue')
    },
    {
      path: '/',
      name: 'Main',
      component: () => import('@/layout/AppMain.vue'),
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/Dashboard.vue')
        },
        // Pay-ins
        {
          path: 'tradeOrder',
          name: 'TradeOrder',
          component: () => import('@/views/Pay-ins/TradeOrder.vue')
        },
        {
          path: 'TradeOrder',
          name: 'TradeOrderApi',
          component: () => import('@/views/Pay-ins/TradeOrder.vue')
        },
        {
          path: 'tradeOrder/create',
          name: 'CreateTradeOrder',
          component: () => import('@/views/Pay-ins/CreateTradeOrder.vue')
        },
        {
          path: 'tradeOrder/edit',
          name: 'EditTradeOrder',
          component: () => import('@/views/Pay-ins/CreateTradeOrder.vue')
        },
        {
          path: 'tradeOrder/detail',
          name: 'TradeOrderDetail',
          component: () => import('@/views/Pay-ins/TradeOrderDetail.vue')
        },
        {
          path: 'tradeReceipt',
          name: 'TradeReceipt',
          component: () => import('@/views/Pay-ins/TradeReceipt.vue')
        },
        {
          path: 'tradeReceipt/detail',
          name: 'TradeReceiptDetail',
          component: () => import('@/views/Pay-ins/TradeReceiptDetail.vue')
        },
        {
          path: 'TradeReceipt',
          name: 'TradeReceiptApi',
          component: () => import('@/views/Pay-ins/TradeReceipt.vue')
        },
        // Conversions (formerly Exchange)
        {
          path: 'exchangeOrder',
          name: 'ExchangeOrder',
          component: () => import('@/views/Conversions/ExchangeOrder.vue')
        },
        {
          path: 'exchangeOrder/list',
          name: 'ExchangeOrderList',
          component: () => import('@/views/Conversions/ExchangeOrderList.vue')
        },
        {
          path: 'exchangeOrder/detail',
          name: 'ExchangeOrderDetail',
          component: () => import('@/views/Conversions/ExchangeOrderDetail.vue')
        },
        {
          path: 'exchange/initiate',
          name: 'ExchangeInitiate',
          component: () => import('@/views/Conversions/ExchangeOrder.vue')
        },
        {
          path: 'exchange/ExchangeOrder',
          name: 'ExchangeOrderApi2',
          component: () => import('@/views/Conversions/ExchangeOrder.vue')
        },
        // Settlements (formerly Settlement)
        {
          path: 'settlementOrder',
          name: 'SettlementOrder',
          component: () => import('@/views/Settlements/SettlementOrder.vue')
        },
        {
          path: 'settlementExchangeOrder',
          name: 'SettlementExchangeOrderApi',
          component: () => import('@/views/Settlements/SettlementOrder.vue')
        },
        {
          path: 'createSettlementOrder',
          name: 'CreateSettlementOrder',
          component: () => import('@/views/Settlements/CreateSettlementOrder.vue')
        },
        {
          path: 'laborSettlementOrder',
          name: 'LaborSettlementSelect',
          component: () => import('@/views/Settlements/LaborSettlementSelect.vue')
        },
        {
          path: 'laborSettlement/apply',
          name: 'LaborSettlementApply',
          component: () => import('@/views/Settlements/LaborSettlementApply.vue')
        },
        {
          path: 'laborSettlement/confirm',
          name: 'LaborSettlementConfirm',
          component: () => import('@/views/Settlements/LaborSettlementConfirm.vue')
        },
        {
          path: 'settlementWithdrawOrder',
          name: 'SettlementWithdrawOrder',
          component: () => import('@/views/Settlements/WithdrawOrder.vue')
        },
        {
          path: 'exchangeSettlementPaymentOrder',
          name: 'ExchangeSettlementPaymentOrderApi',
          component: () => import('@/views/Settlements/WithdrawOrder.vue')
        },
        {
          path: 'settlementQuota',
          name: 'SettlementQuota',
          component: () => import('@/views/Settlements/Quota.vue')
        },
        {
          path: 'ExchangeSettlementLimitQuery',
          name: 'ExchangeSettlementLimitQueryApi',
          component: () => import('@/views/Settlements/Quota.vue')
        },
        // Pay-outs (formerly Loan)
        {
          path: 'transferRemittance',
          name: 'TransferRemittance',
          component: () => import('@/views/Pay-outs/TransferRemittance.vue')
        },
        {
          path: 'transferRemittance/orderRecord',
          name: 'TransferRemittanceOrder',
          component: () => import('@/views/Pay-outs/TransferRemittanceOrder.vue')
        },
        {
          path: 'transferRemittance/orderDetail',
          name: 'TransferRemittanceOrderDetail',
          component: () => import('@/views/Pay-outs/TransferRemittanceOrderDetail.vue')
        },
        {
          path: 'TransferRemittance',
          name: 'TransferRemittanceApi',
          component: () => import('@/views/Pay-outs/TransferRemittance.vue')
        },
        {
          path: 'remittance/apply',
          name: 'RemittanceApply',
          component: () => import('@/views/Pay-outs/RemittanceApply.vue')
        },
        {
          path: 'remittance/confirm',
          name: 'RemittanceConfirm',
          component: () => import('@/views/Pay-outs/RemittanceConfirm.vue')
        },
        // Fund Management
        {
          path: 'myWallet',
          name: 'MyWallet',
          component: () => import('@/views/FundManagement/MyWallet.vue')
        },
        {
          path: 'myFunds',
          name: 'MyFundsApi',
          component: () => import('@/views/FundManagement/MyWallet.vue')
        },
        {
          path: 'fundFlow',
          name: 'FundFlow',
          component: () => import('@/views/FundManagement/FundFlow.vue')
        },
        // Account Management
        {
          path: 'foreignTradeAccount',
          name: 'ForeignTradeAccount',
          component: () => import('@/views/AccountManagement/ForeignTradeAccount.vue')
        },
        {
          path: 'account/ForeignPayment',
          name: 'ForeignTradeAccountApi',
          component: () => import('@/views/AccountManagement/ForeignTradeAccount.vue')
        },
        {
          path: 'foreignTradeAccount/apply',
          name: 'ApplyForeignTradeAccount',
          component: () => import('@/views/AccountManagement/ApplyForeignTradeAccount.vue')
        },
        {
          path: 'foreignTradeAccount/detail',
          name: 'ForeignTradeAccountDetail',
          component: () => import('@/views/AccountManagement/ForeignTradeAccountDetail.vue')
        },
        {
          path: 'rmbSettlementAccount',
          name: 'RmbSettlementAccount',
          component: () => import('@/views/AccountManagement/RmbSettlementAccount.vue')
        },
        {
          path: 'account/RmbSettlement',
          name: 'RmbSettlementAccountApi',
          component: () => import('@/views/AccountManagement/RmbSettlementAccount.vue')
        },
        {
          path: 'rmbSettlementAccount/add',
          name: 'AddRmbSettlementAccount',
          component: () => import('@/views/AccountManagement/AddRmbSettlementAccount.vue')
        },
        {
          path: 'rmbSettlementAccount/detail',
          name: 'RmbSettlementAccountDetail',
          component: () => import('@/views/AccountManagement/RmbSettlementAccountDetail.vue')
        },
        {
          path: 'overseasRemittanceAccount',
          name: 'OverseasRemittanceAccount',
          component: () => import('@/views/AccountManagement/OverseasRemittanceAccount.vue')
        },
        {
          path: 'account/OverseasRemittance',
          name: 'OverseasRemittanceAccountApi',
          component: () => import('@/views/AccountManagement/OverseasRemittanceAccount.vue')
        },
        {
          path: 'overseasRemittanceAccount/add',
          name: 'AddOverseasRemittanceAccount',
          component: () => import('@/views/AccountManagement/AddOverseasRemittanceAccount.vue')
        },
        {
          path: 'overseasRemittanceAccount/detail',
          name: 'OverseasRemittanceAccountDetail',
          component: () => import('@/views/AccountManagement/OverseasRemittanceAccountDetail.vue')
        },
        // My Account (formerly My)
        {
          path: 'announcementList',
          name: 'AnnouncementList',
          component: () => import('@/views/MyAccount/Announcement.vue')
        },
        {
          path: 'NotificationList',
          name: 'NotificationListApi',
          component: () => import('@/views/MyAccount/Announcement.vue')
        },
        {
          path: 'enterpriseCertification',
          name: 'EnterpriseCertification',
          component: () => import('@/views/MyAccount/enterprise/index.vue')
        },
        {
          path: 'enterpriseCertification/material',
          name: 'EnterpriseCertificationMaterial',
          component: () => import('@/views/MyAccount/enterprise/material.vue')
        },
        {
          path: 'enterpriseCertification/basicInfo',
          name: 'EnterpriseBasicInfo',
          component: () => import('@/views/MyAccount/enterprise/basicInfo.vue')
        },
        {
          path: 'enterpriseCertification/basicInfoOther',
          name: 'EnterpriseBasicInfoOther',
          component: () => import('@/views/MyAccount/enterprise/basicInfoOther.vue')
        },
        {
          path: 'enterpriseCertification/basicInfoHongkong',
          name: 'EnterpriseBasicInfoHongkong',
          component: () => import('@/views/MyAccount/enterprise/basicInfoHongkong.vue')
        },
        {
          path: 'enterpriseCertification/shareholder',
          name: 'EnterpriseShareholder',
          component: () => import('@/views/MyAccount/enterprise/shareholder.vue')
        },
        {
          path: 'enterpriseCertification/trade',
          name: 'EnterpriseTrade',
          component: () => import('@/views/MyAccount/enterprise/trade.vue')
        },
        {
          path: 'NetworkAuthentication',
          name: 'NetworkAuthenticationApi',
          component: () => import('@/views/MyAccount/enterprise/index.vue')
        },
        {
          path: 'accountSecurity',
          name: 'AccountSecurity',
          component: () => import('@/views/MyAccount/Security.vue')
        },
        {
          path: 'security',
          name: 'SecurityApi',
          component: () => import('@/views/MyAccount/Security.vue')
        },
        {
          path: 'updateEmail',
          name: 'UpdateEmail',
          component: () => import('@/views/MyAccount/UpdateEmail.vue')
        },
        {
          path: 'updatePassword',
          name: 'UpdatePassword',
          component: () => import('@/views/MyAccount/UpdatePassword.vue')
        },
        {
          path: 'addRole',
          name: 'AddRole',
          component: () => import('@/views/MyAccount/AddRole.vue')
        },
        {
          path: 'roleManagement',
          name: 'RoleManagement',
          component: () => import('@/views/MyAccount/Role.vue')
        },
        {
          path: 'RoleList',
          name: 'RoleListApi',
          component: () => import('@/views/MyAccount/Role.vue')
        },
        {
          path: 'operatorManagement',
          name: 'OperatorManagement',
          component: () => import('@/views/MyAccount/Operator.vue')
        },
        {
          path: 'OperatorList',
          name: 'OperatorListApi',
          component: () => import('@/views/MyAccount/Operator.vue')
        },
        {
          path: 'addOperator',
          name: 'AddOperator',
          component: () => import('@/views/MyAccount/AddOperator.vue')
        },
        {
          path: 'editOperator',
          name: 'EditOperator',
          component: () => import('@/views/MyAccount/EditOperator.vue')
        },
        {
          path: 'keyManagement',
          name: 'KeyManagement',
          component: () => import('@/views/MyAccount/Key.vue')
        },
        {
          path: 'key',
          name: 'KeyApi',
          component: () => import('@/views/MyAccount/Key.vue')
        },
        {
          path: 'pubKey',
          name: 'PubKeyApi',
          component: () => import('@/views/MyAccount/Key.vue')
        },
        {
          path: 'referralLink',
          name: 'ReferralLink',
          component: () => import('@/views/MyAccount/ReferralLink.vue')
        },
        // Digital Currency
        {
          path: 'digitalAccount',
          name: 'DigitalAccount',
          component: () => import('@/views/DigitalCurrency/DigitalAccount.vue')
        },
        {
          path: 'DigitalAccount',
          name: 'DigitalAccountApi',
          component: () => import('@/views/DigitalCurrency/DigitalAccount.vue')
        },
        {
          path: 'digitalDeposit',
          name: 'DigitalDeposit',
          component: () => import('@/views/DigitalCurrency/DigitalDeposit.vue')
        },
        {
          path: 'DigitalDeposit',
          name: 'DigitalDepositApi',
          component: () => import('@/views/DigitalCurrency/DigitalDeposit.vue')
        },
        {
          path: 'digitalWithdrawal',
          name: 'DigitalWithdrawal',
          component: () => import('@/views/DigitalCurrency/DigitalWithdrawal.vue')
        },
        {
          path: 'DigitalWithdrawal',
          name: 'DigitalWithdrawalApi',
          component: () => import('@/views/DigitalCurrency/DigitalWithdrawal.vue')
        },
        {
          path: 'digitalWithdraw',
          name: 'DigitalWithdraw',
          component: () => import('@/views/DigitalCurrency/DigitalWithdraw.vue')
        },
        {
          path: 'DigitalWithdraw',
          name: 'DigitalWithdrawApi',
          component: () => import('@/views/DigitalCurrency/DigitalWithdraw.vue')
        },
        {
          path: 'digitalExchange',
          name: 'DigitalExchange',
          component: () => import('@/views/DigitalCurrency/DigitalExchange.vue')
        },
        {
          path: 'DigitalExchange',
          name: 'DigitalExchangeApi',
          component: () => import('@/views/DigitalCurrency/DigitalExchange.vue')
        },
        // Legal Account
        {
          path: 'legalAccount',
          name: 'LegalAccount',
          component: () => import('@/views/LegalAccount/LegalAccount.vue')
        },
        {
          path: 'legalWithdraw',
          name: 'LegalWithdraw',
          component: () => import('@/views/LegalAccount/LegalWithdraw.vue')
        },
        {
          path: 'bankAccount',
          name: 'BankAccount',
          component: () => import('@/views/LegalAccount/BankAccount.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/forgot-password', '/agreements/user-agreement-zh', '/agreements/user-agreement-en', '/agreements/privacy-policy-zh', '/agreements/privacy-policy-en']
  
  if (publicPages.includes(to.path)) {
    next()
    return
  }
  
  const token = localStorage.getItem('token')
  if (!token) {
    next('/login')
    return
  }
  
  next()
})

// 避免 NavigationDuplicated 错误
const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js